module.exports = __webpack_public_path__ + "static/media/user1.726e3948.jpg";